import React from 'react';
import { SectionFade } from './ui/SectionFade';
export function Transformation() {
  return <section className="py-32 px-4 bg-brand-black relative overflow-hidden" data-id="element-172">
      {/* Cinematic lighting effect */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-[radial-gradient(ellipse_at_top,rgba(200,255,0,0.15)_0%,transparent_60%)] pointer-events-none" data-id="element-173"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-174">
        <SectionFade data-id="element-175">
          <h2 className="font-bebas text-5xl md:text-7xl text-center mb-12 tracking-tight" data-id="element-176">
            LO QUE CAMBIA EN{' '}
            <span className="text-brand-neon" data-id="element-177">UNA SEMANA:</span>
          </h2>
        </SectionFade>

        <SectionFade delay={0.2} data-id="element-178">
          <div className="relative" data-id="element-179">
            {/* Quote marks decoration */}
            <span className="absolute -top-12 -left-8 text-8xl font-serif text-white/10 select-none" data-id="element-180">
              "
            </span>

            <div className="border-l-4 border-brand-neon pl-8 md:pl-12 py-4" data-id="element-181">
              <p className="font-inter text-2xl md:text-4xl text-white leading-snug font-light italic" data-id="element-182">
                Imagina entrar al supermercado con total confianza. Ya no te
                detienes a dudar frente a un estante. Miras el reverso, detectas
                el engaño en 5 segundos y sigues adelante.
                <br data-id="element-183" />
                <br data-id="element-184" />
                <strong className="text-brand-neon font-semibold not-italic" data-id="element-185">
                  Tu digestión mejora, tu mente se aclara y, por primera vez,
                  tienes el control total de lo que entra en tu hogar.
                </strong>
              </p>
            </div>
          </div>
        </SectionFade>
      </div>
    </section>;
}